import styled from "styled-components";
import { EvtsFooter } from "../../shared/EvtsFooter";

interface ComponentProps {
    children: any;
}

const Page = styled.div`
    background-color: ${(props) => props.theme.colors.background};
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    &::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.colors.border};
        width: 4px;
        -webkit-border-radius: 10px;
    }
    &::-webkit-scrollbar {
        width: 15px;
        background: ${(props) => props.theme.colors.offwhite}; 
        width: 8px;
        -webkit-border-radius: 10px;
    }
`;

const PageWrapper: React.FC<ComponentProps> = ({ children }) => {
    return (
    <>
        <Page>{children}        <EvtsFooter />  </Page>
    </>
    );
};

export default PageWrapper;
